//TODO Please complete [.env] file before filling the data below!!!

//? This is global meta tag config.
export const SiteMetaConfig = {
  site_language: "en", //? This is global site language.
  site_url: "http://localhost:8000", //? This is global site base URL. It supposed to be the domain with protocal.
  site_name: "Lilly's Face Painting Melbourne", //? This is global site name. It will be showed beside every title. And it's the dafault title for Index Page.
  site_description: "Professional Face Painting For Lasting Memories", //? This is global site description. It will be showed for every page. And it's the dafault title for Index Page.
  site_image: "/assets/icon.png", //? This is global banner image. It is the dafault image that will be showed on every social media card.
  site_twitter_handle: "", //? This is option to add twitter username. It will be used when sharing to twitter.
//  site_facebook_app_id: "", //? This is Facebook App ID and it is used to get data in Facebook insights.
}



//? This is used to override meta data for Index Page.
//! Writing anything here will override dafault data.
export const LandingMetaConfig = {
  seo_title: "", //? This is used to override title for Index Page.
  seo_description: "", //? This is used to override description for Index Page.
  // seo_image: "https://www.example.ie/og-image-03.jpg", //? This is used to override banner image for Index Page.
  
  //! IT IS BOOLEAN
//  seo_no_index: "", //? This is used to mark Index Page as NO INDEX for search engines.

  //! IT IS BOOLEAN
//  seo_no_follow: "", //? This is used to mark Index Page as NO FOLLOW for search engines.
}



//? This is for controlling which parts will be visible in Index Page.
export const LandingPageConfig = {
  //! IT IS BOOLEAN
  hero_section: "true", //? This is for controlling if Hero Section on Index Page will be showed.
  
  //! IT IS BOOLEAN
  video_section: "true", //? This is for controlling if Video Section on Index Page will be showed.
  
  //! IT IS BOOLEAN
  socialproof_section: "true", //? This is for controlling if Social Proof Section on Index Page will be showed.

  //! IT IS BOOLEAN
  benefits_section: "true", //? This is for controlling if Benefits Section on Index Page will be showed.

  //! IT IS BOOLEAN
  about_section: "true", //? This is for controlling if About Section on Index Page will be showed.

  //! IT IS BOOLEAN
  faq_section: "true", //? This is for controlling if Faq Section on Index Page will be showed.

  //! IT IS BOOLEAN
  calltoaction_section: "", //? This is for controlling if Call To Action Section on Index Page will be showed.



  //! IT IS BOOLEAN
  header_option: "true", //? This is for controlling if Header on top of Index Page will be showed.

  //! IT IS BOOLEAN
  footer_option: "true", //? This is for controlling if Footer on bottom of Index Page will be showed.



  //! IT IS BOOLEAN
  counter_bar_option: "true", //? This is for controlling if Counter Bar on Index Page will be showed.

  //! IT IS BOOLEAN
  footer_bar_option: "true", //? This is for controlling if Footer Bar on Index Page will be showed.

  //! IT IS BOOLEAN
  //TODO: Only turn it off if Lead Form is never used in Index Page.
  modal_option: "", //? This is for controlling if Modal with Lead Form will be rendered on Index Page.

  //! IT IS BOOLEAN
  modal_outside_close: "", //? This is for controlling if clicking on outside of the Modal will close the Modal on Index Page.



  //! IT IS BOOLEAN
  //TODO: Only turn it on if something written in content.js file
//  popup_option: "", //? This is for controlling if PopUp on Index Page will be showed.



  //! IT IS BOOLEAN
  //TODO: Only turn it on if something written in animation.js file
//  animation_section: "", //? This is for controlling if Animation Section on Index Page will be showed.

  //! IT IS BOOLEAN
  //TODO: Only turn it on if something written in special.js file
//  special_section: "", //? This is for controlling if Special Section on Index Page will be showed.
}



//? This is for data in Feedback Page
export const FeedbackConfig = {
//  review_submission_link: "", //? This is for submitting only good reviews. Use Google/Facebook/Yelp review giving link.
}



//? This is for configuring different policy parts in Help Page.
export const HelpConfig = {
  //! IT IS BOOLEAN
  default_privacy_policy: "yes", //? This is for controlling if Default Privacy Policy on Help Page will be showed.

  //! IT IS BOOLEAN
  default_terms_and_conditions: "yes", //? This is for controlling if Default Terms And Conditions on Help Page will be showed.

  //! IT IS BOOLEAN
  default_disclaimer: "yes", //? This is for controlling if Default Disclaimer on Help Page will be showed.

  lawsuit_amount: "100.00", //? This is for setting highest lawsuit Amount in disclaimer.
  lawsuit_country: "Australia", //? This is for setting lawsuit Country in disclaimer.
  lawsuit_city: "Melbourne", //? This is for setting lawsuit City in disclaimer.
  lawsuit_language: "English", //? This is for setting lawsuit Language in disclaimer.
}



//? This is for adding Link in Header.
//! IT IS ARRAY
export const HeaderLinkData = [
  {
    navigation_link_label: "Home", //? This is for setting Link Label that will be showed in Header.

    //TODO: Don't fill this if "navigation_url_link" is filled.
    navigation_page_link: "/", //? This is for setting Page Link to the Link Label in Header.

    //TODO: Don't fill this if "navigation_page_link" is filled.
    navigation_url_link: "", //? This is for setting URL Link to the Link Label in Header.

    //! IT IS BOOLEAN
    navigation_url_new_tab: "", //? This is for controlling if the URL Link will be opened in a new window in Header.
  },
/*  {
    navigation_link_label: "Tags", //? This is for setting Link Label that will be showed in Header.

    //TODO: Don't fill this if "navigation_url_link" is filled.
    navigation_page_link: "/blog/tags", //? This is for setting Page Link to the Link Label in Header.

    //TODO: Don't fill this if "navigation_page_link" is filled.
    navigation_url_link: "", //? This is for setting URL Link to the Link Label in Header.

    //! IT IS BOOLEAN
    navigation_url_new_tab: "", //? This is for controlling if the URL Link will be opened in a new window in Header.
  },
  {
    navigation_link_label: "Blog", //? This is for setting Link Label that will be showed in Header.

    //TODO: Don't fill this if "navigation_url_link" is filled.
    navigation_page_link: "/blog/blog-page-1", //? This is for setting Page Link to the Link Label in Header.

    //TODO: Don't fill this if "navigation_page_link" is filled.
    navigation_url_link: "", //? This is for setting URL Link to the Link Label in Header.

    //! IT IS BOOLEAN
    navigation_url_new_tab: "", //? This is for controlling if the URL Link will be opened in a new window in Header.
  }, */
  {
    navigation_link_label: "Help", //? This is for setting Link Label that will be showed in Header.

    //TODO: Don't fill this if "navigation_url_link" is filled.
    navigation_page_link: "/help", //? This is for setting Page Link to the Link Label in Header.

    //TODO: Don't fill this if "navigation_page_link" is filled.
    navigation_url_link: "", //? This is for setting URL Link to the Link Label in Header.

    //! IT IS BOOLEAN
    navigation_url_new_tab: "", //? This is for controlling if the URL Link will be opened in a new window in Header.
  },
]



//? This is for adding Link in a dropdown container in Header.
//! IT IS ARRAY
export const HeaderListData = [
  // {
  //   navigation_list_name: "Dropdown Container", //? This is for setting Label for the Dropdown Container that will be showed in Header.

  //   //! IT IS ARRAY
  //   navigation_list_items: [
  //     {
  //       navigation_link_label: "", //? This is for setting Link Label that will be showed in Header.
    
  //       //TODO: Don't fill this if "navigation_url_link" is filled.
  //       navigation_page_link: "", //? This is for setting Page Link to the Link Label in Header.
    
  //       //TODO: Don't fill this if "navigation_page_link" is filled.
  //       navigation_url_link: "", //? This is for setting URL Link to the Link Label in Header.
    
  //       //! IT IS BOOLEAN
  //       navigation_url_new_tab: "", //? This is for controlling if the URL Link will be opened in a new window in Header.
  //     },
  //   ],
  // },
]



//? This is for controlling which parts will be visible of Header.
export const HeaderConfig = {
  //! IT IS BOOLEAN
  navigation_brand_logo: "/assets/icon.png", //? This is for controlling if Logo will be showed in Header.

  //! IT IS BOOLEAN
  // navigation_brand_name: "True", //? This is for controlling if Name will be showed in Header.
}



//? This is for configuring different parts of Footer.
export const FooterConfig = {
  time_monday: "09:00 - 19:00", //? This is for setting Opening Hours for Monday in Footer.
  time_tuesday: "09:00 - 19:00", //? This is for setting Opening Hours for Tuesday in Footer.
  time_wednesday: "09:00 - 19:00", //? This is for setting Opening Hours for Wednesday in Footer.
  time_thursday: "09:00 - 19:00", //? This is for setting Opening Hours for Thursday in Footer.
  time_friday: "09:00 - 19:00", //? This is for setting Opening Hours for Friday in Footer.
  time_saturday: "09:00 - 21:30", //? This is for setting Opening Hours for Saturday in Footer.
  time_sunday: "09:00 - 21:30", //? This is for setting Opening Hours for Sunday in Footer.
  email_label: "info@lillysfacepainting.com.au", //? This is for setting Email Label in Footer.
  email_url_link: "info@lillysfacepainting.com.au", //? This is for setting Email Address for Email Label in Footer. Should be same as Email Label in Footer.
  phone_label: "+61408447829", //? This is for setting Phone Label in Footer.
  phone_url_link: "tel:+61408447829", //? This is for setting Phone Number for Phone Label in Footer. Should be same as Phone Label but can contain country code too.
  location_label: "Edgars Rd, Thomastown VIC 3074, Australia", //? This is for setting Location Label in Footer.
  location_url_link: "https://share.google/CTqEmCJkmFVAu7ruw", //? This is for setting Google Maps Location Link for Location Label in Footer.
  // social_profile_youtube: "https://goo.gl/maps/tXjgXKitJhM6iNny5", //? This is for setting youtube Link in Footer.
  social_profile_facebook: "https://www.facebook.com/lillysfacepaintingmelbourne", //? This is for setting Facebook Link in Footer.
  social_profile_instagram: "https://www.instagram.com/lillysfacepainting/", //? This is for setting Instagram Link in Footer.
  // social_profile_pinterest: "https://goo.gl/maps/tXjgXKitJhM6iNny5", //? This is for setting Pinterest Link in Footer.
  // social_profile_tiktok: "https://goo.gl/maps/tXjgXKitJhM6iNny5", //? This is for setting Tiktok Link in Footer.
  // social_profile_twitter: "https://goo.gl/maps/tXjgXKitJhM6iNny5", //? This is for setting Twitter Link in Footer.
  // social_profile_yelp: "https://goo.gl/maps/tXjgXKitJhM6iNny5", //? This is for setting Yelp Link in Footer.
  // social_profile_etsy: "https://goo.gl/maps/tXjgXKitJhM6iNny5", //? This is for setting Etsy Link in Footer.
  footer_brand_text: "Owned By", //? This is for setting Text before Footer Label in Footer.
  footer_brand_label: "Lilly's Face Painting Melbourne", //? This is for setting Footer Label in Footer.
  footer_brand_link: "", //? This is for setting Footer Link for Footer Label in Footer. This is optional.

  //! IT IS BOOLEAN
  footer_info_part: "yes", //? This is for controlling if Info Part in Footer will be showed. This contains Email, Number and Address.

  //! IT IS BOOLEAN
  //TODO: Only turn it on if something written in "FooterData"
  // footer_link_part: "", //? This is for controlling if Link Part in Footer will be showed. This contains multiple links.
  footer_time_part: "yes", //? This is for controlling if Time Part in Footer will be showed. This contains Opening Hours.

  //! IT IS BOOLEAN
  footer_map_part: "yes", //? This is for controlling if Map Part in Footer will be showed. This contains Map Image.
}



//? This is for adding URL And Page Link in Footer.
//TODO: Turn it on inside "footer_link_part"
//! IT IS ARRAY
export const FooterData = [
  // {
  //   footer_label: "Pacito", //? This is for setting Footer Link Label in Footer.
    
  //TODO: Don't fill this if "footer_page_link" is filled.
  //   footer_url_link: "https://www.w3schools.com/css/tryit.asp?filename=trycss_grid_grid-template-rows", //? This is for setting URL Link to the Footer Link Label in Footer.

  //TODO: Don't fill this if "footer_url_link" is filled.
  //   footer_page_link: "", //? This is for setting Page Link to the Footer Link Label in Footer.
  // },
]



//? This is for configuring different parts of Counter Bar.
export const CounterBarConfig = {
  minimum_viewer: "1", //? This is for setting Minimum Viewer Count in Counter Bar.
  maximum_viewer: "7", //? This is for setting Maximum Viewer Count in Counter Bar.
  bar_show_delay: "20000", //? This is for setting Delay Between Each Appearance of Counter Bar in millisecond.
  bar_show_time: "5000", //? This is for setting Visibility Time of Counter Bar in millisecond.
}



//? This is for configuring different parts of Footer Bar.
export const FooterBarConfig = {
  //Coprwriting: Take this quick quiz to see if you qualify for our service
  footer_bar_text: "Take a quiz while waiting :)", //? This is for setting Text in Footer Bar.
  button_label: "Take Quiz", //? This is for setting Button Label in Footer Bar. By default it will open Lead Form.

  //TODO: Don't fill this if "button_url_link" is filled.
//  button_page_link: "", //? This is for setting Page Link to the Button Label in Footer Bar.

  //TODO: Don't fill this if "button_page_link" is filled.
//  button_url_link: "", //? This is for setting URL Link to the Button Label in Footer Bar.

  //! IT IS BOOLEAN
//  button_url_new_tab: "", //? This is for controlling if the URL Link will be opened in a new window in Footer Bar.
}



//? This is for configuring Hero Section of Index Page.
export const HeroConfig = {
  //TODO: Don't fill this if "hero_heading_text" is filled.
  //hero_heading_typewriter_text: ["Live Life King Size", "Live Life Queen Size"],
  //hero_heading_typewriter_before_text: "Best lover can",
  //hero_heading_typewriter_after_text: "But no one...",

  //TODO: Don't fill this if "hero_heading_typewriter_text" is filled.
  hero_heading_text: "Professional Face Painting For Lasting Memories", //? This is for setting Heading Text in Hero Section of Index Page.
  hero_text: "Let us paint a smile on your face!", //? This is for setting Sub-Heading Text in Hero Section of Index Page.
  button_label: "Call Now", //? This is for setting Button Label in Hero Section. By default it will open Lead Form.

  //TODO: Don't fill this if "button_url_link" is filled.
//  button_page_link: "", //? This is for setting Page Link to the Button Label in Hero Section.

  //TODO: Don't fill this if "button_page_link" is filled.
  button_url_link: "tel:+61408447829",

  //! IT IS BOOLEAN
  button_url_new_tab: "yes", //? This is for controlling if the URL Link will be opened in a new window in Hero Section.
//  link_label: "", //? This is for setting Link Label in Hero Section. By default it will open Lead Form.

  //TODO: Don't fill this if "link_url_link" is filled.
//  link_page_link: "", //? This is for setting Page Link to the Link Label in Hero Section.

  //TODO: Don't fill this if "link_page_link" is filled.
//  link_url_link: "", //? This is for setting URL Link to the Link Label in Hero Section.

  //! IT IS BOOLEAN
//  link_url_new_tab: "", //? This is for controlling if the URL Link will be opened in a new window in Hero Section.
}



//? This is for configuring Video Section of Index Page.
export const VideoConfig = {
  section_header: "Your Imagination Is Our Canvas", //? This is for setting Heading Text in Video Section of Index Page.
  section_sub_header: "Bringing your ideas to life with bold colors, detailed designs, and a gentle touch. From birthday parties to special events, we turn every face into a work of art that sparks joy and lasting memories.", //? This is for setting Sub-Heading Text in Video Section of Index Page.

  video_url: "https://youtu.be/yu-pP-yaohY", //? This is for setting Video URL in Video Section.
//  video_thumbnail: "", //? This is for setting Video Thumbnail in Video Section.
//  video_loop: "", //? This is for controlling if Video will be Looped in Video Section.
//  video_mute: "", //? This is for controlling if Video will be Muted in Video Section.
//  video_controls: "", //? This is for controlling if Video Controls will be showed in Video Section.
}



//? This is for configuring Social Proof Section of Index Page.
export const SocialProofConfig = {
  section_header: "Customer Reviews", //? This is for setting Heading Text in Social Proof Section of Index Page.
//  section_sub_header: "", //? This is for setting Sub-Heading Text in Social Proof Section of Index Page.

  //TODO: Set the number of Slides written in "SocialProofData"
  number_of_slides: "7", //? This is for setting Number Of Slides in Social Proof Section.
  visible_of_slides: "1", //? This is for setting Number Of Visible Slides At Once in Social Proof Section.
  interval_of_slides: "2500", //? This is for setting Delay Between Each Appearance in Social Proof Section.
}



//? This is for adding URL And Page Link in Footer.
//TODO: Set the number of Slides inside "number_of_slides"
//! IT IS ARRAY
export const SocialProofData = [
  {
//  social_proof_heading: "", //? This is for setting Heading in Social Proof Section.
    social_proof_text: "Lilly was absolutely fantastic at my daughter’s 5th birthday! She arrived on time, was professional yet so warm and approachable, and instantly made the kids feel comfortable. Her face painting was beautiful and creative, and she happily took requests, making sure each child left with a big smile.", //? This is for setting Text in Social Proof Section.
    social_proof_author: "Alisar A", //? This is for setting Author in Social Proof Section.
//    social_proof_image: "", //? This is for setting Image in Social Proof Section.
//    social_proof_image_height: "", //? This is for setting Image Height in Social Proof Section. This is for SEO.
//    social_proof_image_width: "", //? This is for setting Image Width in Social Proof Section. This is for SEO.
//    social_proof_image_stretch_width: "", //? This is for setting Image Stretch Width in Social Proof Section.
  },
  {
//  social_proof_heading: "", //? This is for setting Heading in Social Proof Section.
    social_proof_text: "We had Lilly at our son's birthday party, and she was absolutely fantastic! The kids loved having their face painted, and Lilly was incredibly patient and friendly with each child. I had so many parents asking for her number because she was just so sweet with the kids and incredibly talented. I highly recommend Lilly.", //? This is for setting Text in Social Proof Section.
    social_proof_author: "Lisa Barbaro", //? This is for setting Author in Social Proof Section.
//    social_proof_image: "", //? This is for setting Image in Social Proof Section.
//    social_proof_image_height: "", //? This is for setting Image Height in Social Proof Section. This is for SEO.
//    social_proof_image_width: "", //? This is for setting Image Width in Social Proof Section. This is for SEO.
//    social_proof_image_stretch_width: "", //? This is for setting Image Stretch Width in Social Proof Section.
  },
  {
//  social_proof_heading: "", //? This is for setting Heading in Social Proof Section.
    social_proof_text: "I was recently at a birthday party and Lilly's face painting was there and she is brilliant at what she does! Kids absolutely loved her and her work is by far the best I've seen. She was very patient with the kids which makes every parent feel at ease. Highly recommend to anyone having a kids party, will be a huge hit!", //? This is for setting Text in Social Proof Section.
    social_proof_author: "Isra Yakan", //? This is for setting Author in Social Proof Section.
//    social_proof_image: "", //? This is for setting Image in Social Proof Section.
//    social_proof_image_height: "", //? This is for setting Image Height in Social Proof Section. This is for SEO.
//    social_proof_image_width: "", //? This is for setting Image Width in Social Proof Section. This is for SEO.
//    social_proof_image_stretch_width: "", //? This is for setting Image Stretch Width in Social Proof Section.
  },
  {
//  social_proof_heading: "", //? This is for setting Heading in Social Proof Section.
    social_proof_text: "My 4 year old was obsessed with her unicorn face paint, she refused to wash it off by the end of the night! Lilly was sweet and patient with the kids and her quality of work was fantastic! Highly recommend! Thanks Lilly!", //? This is for setting Text in Social Proof Section.
    social_proof_author: "Taties D", //? This is for setting Author in Social Proof Section.
//    social_proof_image: "", //? This is for setting Image in Social Proof Section.
//    social_proof_image_height: "", //? This is for setting Image Height in Social Proof Section. This is for SEO.
//    social_proof_image_width: "", //? This is for setting Image Width in Social Proof Section. This is for SEO.
//    social_proof_image_stretch_width: "", //? This is for setting Image Stretch Width in Social Proof Section.
  },
  {
//  social_proof_heading: "", //? This is for setting Heading in Social Proof Section.
    social_proof_text: "Thank you, Lilly, for bringing magic to the kinder children’s faces at the Christmas party! They were all so delighted with their looks, and their smiles said it all. Highly recommend your incredible talent!", //? This is for setting Text in Social Proof Section.
    social_proof_author: "Danielle Kalafatis", //? This is for setting Author in Social Proof Section.
//    social_proof_image: "", //? This is for setting Image in Social Proof Section.
//    social_proof_image_height: "", //? This is for setting Image Height in Social Proof Section. This is for SEO.
//    social_proof_image_width: "", //? This is for setting Image Width in Social Proof Section. This is for SEO.
//    social_proof_image_stretch_width: "", //? This is for setting Image Stretch Width in Social Proof Section.
  },
  {
//  social_proof_heading: "", //? This is for setting Heading in Social Proof Section.
    social_proof_text: "Thank you Lilly for doing such a great job today at my son's 3rd birthday. Your face painting skills are next level and all the kids were super happy. Thank you for your patience and for being on time!! High recommended!", //? This is for setting Text in Social Proof Section.
    social_proof_author: "Chammy Lucas", //? This is for setting Author in Social Proof Section.
//    social_proof_image: "", //? This is for setting Image in Social Proof Section.
//    social_proof_image_height: "", //? This is for setting Image Height in Social Proof Section. This is for SEO.
//    social_proof_image_width: "", //? This is for setting Image Width in Social Proof Section. This is for SEO.
//    social_proof_image_stretch_width: "", //? This is for setting Image Stretch Width in Social Proof Section.
  },
  {
//  social_proof_heading: "", //? This is for setting Heading in Social Proof Section.
    social_proof_text: "Lilly is FANTASTIC!!! A total professional, all the parents at our party commented how much the children loved their facepaints. An absolute highlight. We will be rebooking! Thanks so much Lilly", //? This is for setting Text in Social Proof Section.
    social_proof_author: "Jane Marino", //? This is for setting Author in Social Proof Section.
//    social_proof_image: "", //? This is for setting Image in Social Proof Section.
//    social_proof_image_height: "", //? This is for setting Image Height in Social Proof Section. This is for SEO.
//    social_proof_image_width: "", //? This is for setting Image Width in Social Proof Section. This is for SEO.
//    social_proof_image_stretch_width: "", //? This is for setting Image Stretch Width in Social Proof Section.
  },
]



//? This is for configuring About Section of Index Page.
export const AboutConfig = {
  section_header: "Our Story", //? This is for setting Heading Text in About Section of Index Page.
//  section_sub_header: "", //? This is for setting Sub-Heading Text in About Section of Index Page.
  about_text: "Lilly's Face Painting is a Melbourne based business that specialises in providing professional entertainment for children. Fairy Lilly has been working with children for over 10 years as an early childhood educator and created her own magical fairy world back in 2012.\n\nFairy Lilly prides herself in her unique ability to interact with children. From the moment she fly’s in to your house, fluttering her magic fairy wings and sprinkling her fairy dust, imaginations are instantly captured with magical stories of fairy lands. Your child will be taken on a journey of magic, puppetry, dance, games, singing, face painting and glitter tattoos and balloon twisting.\n\nHaving young children of her own, Fairy Lilly understands the importance of children's health and safety. This is why we use only professional high quality, FDA approved paints and cosmetic grade Glitters and products. At all events, we ensure our workstations are always clean and hygienic. We hold public liability insurance to $20m and a current working with children card.", //? This is for setting Text in About Section.

  about_image: "/assets/about.jpg", //? This is for setting Image in About Section.
//  about_image_height: "427", //? This is for setting Image Height in About Section. This is for SEO.
//  about_image_width: "640", //? This is for setting Image Width in About Section. This is for SEO.
 about_image_stretch_width: "100%", //? This is for setting Image Stretch Width in About Section.
}



//? This is for configuring FAQ Section of Index Page.
export const FaqConfig = {
  section_header: "Frequently Asked Questions", //? This is for setting Heading Text in FAQ Section of Index Page.
 section_sub_header: "We know how busy it can be planning and preparing for parties and events, so we have put together some of the most frequently asked questions.", //? This is for setting Sub-Heading Text in FAQ Section of Index Page.
}



//? This is for adding Questions And Answers in FAQ Section of Index Page.
//! IT IS ARRAY
export const FaqData = [
  {
    faq_question: "How long in advance should I book?", //? This is for setting Question in FAQ Section.
    faq_answer: "To ensure you get your desired date and time, it is advisable that you book as soon as possible. Keep in mind September-December are our busiest months.", //? This is for setting Answer in FAQ Section.
  },
  {
    faq_question: "What time will the entertainer arrive?",
    faq_answer: "We will arrive to your event 10-15 minutes before to allow time to set up.",
  },
  {
    faq_question: "How many faces can be painted in an hour?",
    faq_answer: "We can paint 10 full faces per hour or up to 15 quick faces. For face painting we do have a 2 hour minimum. However on some occasions we may be able to come out for less than 2 hours.",
  },
  {
    faq_question: "What do I need to provide for the face painter?",
    faq_answer: "We come fully equipped with everything including face paints, table and chair. If we are setting up outdoors, we would appreciate being supplied with shelter from the rain and sun.",
  },
  {
    faq_question: "Are your Products safe to use on children's skin?",
    faq_answer: "Yes of course. We use only professional high quality, FDA approved paints and cosmetic grade Glitters and products. At all events we ensure our workstations are always clean and hygienic. Brushes are rinsed frequently with a sterile cleaning solution, which is changed frequently.",
  },
  {
    faq_question: "How can the face paints be removed?",
    faq_answer: "Face paints are easy to remove with soap and water using a cleaning cloth. Some colours may stain and can be removed further with baby oil or cleansing creams. Baby wipes are also another helpful option.",
  },
  {
    faq_question: "Do you have insurance?",
    faq_answer: "Yes, we hold public liability insurance to $20m and a current working with children card.",
  },
  {
    faq_question: "What is your payment method?",
    faq_answer: "We require a $50 deposit to secure your booking. The remaining balance can be made via direct deposit 1 week prior to event, otherwise cash can be given on the day.",
  },
  {
    faq_question: "Can you provide multiple entertainers for busier events?",
    faq_answer: "Yes we have a large selection of very talented Face Painters, Balloon Twisters and Children Entertainers that can be booked for busier events.",
  },
]



//? This is for configuring Benefits Section of Index Page.
export const BenefitsConfig = {
  section_header: "Our Services", //? This is for setting Heading Text in Benefits Section of Index Page.
//  section_sub_header: "", //? This is for setting Sub-Heading Text in Benefits Section of Index Page.
}



//? This is for adding Benefits in Benefits Section of Index Page.
//! IT IS ARRAY
export const BenefitsData = [
  {
    benefits_heading: "Balloon Twisting",
    benefits_text: "Balloon twisting is a fun option to add to your party. Children love seeing their favourite balloon design being made right there in front of them from start to finish. Children can choose from a range of options including; Penguin, dog, fish, ladybug, flower bracelet, princess wand, butterfly wand, sword, light saber and many more.",
    button_label: "Call Now",
    button_url_link: "tel:+61408447829",
    button_url_new_tab: "*",
    benefits_image: "/assets/balloon.jpg",
    benefits_image_stretch_width: "100%",
  },
  {
    benefits_heading: "Face Painting", //? This is for setting Heading in Benefits Section.
    benefits_text: "We provide professional and creative face paintings and a picture board with many fun and fancy designs for your child to choose from. The joy of watching a child's eyes light up when they look at themselves in the mirror after being painted is priceless! Whether it is putting on a funny pirate accent, being a superhero, making animal sounds, granting fairy wishes or being pretty princesses.", //? This is for setting Text in Benefits Section.
    button_label: "Call Now", //? This is for setting Button Label in Benefits Section.
    
    //TODO: Don't fill this if "button_url_link" is filled.
    // button_page_link: "", //? This is for setting Page Link to the Button Label in Benefits Section.

    //TODO: Don't fill this if "button_page_link" is filled.
    button_url_link: "tel:+61408447829", //? This is for setting URL Link to the Button Label in Benefits Section.

    //! IT IS BOOLEAN
    button_url_new_tab: "*", //? This is for controlling if the URL Link will be opened in a new window in Benefits Section.
    benefits_image: "/assets/painting.jpg", //? This is for setting Image in Benefits Section.
    // benefits_image_height: "427", //? This is for setting Image Height in Benefits Section. This is for SEO.
    // benefits_image_width: "640", //? This is for setting Image Width in Benefits Section. This is for SEO.
    benefits_image_stretch_width: "100%", //? This is for setting Image Stretch Width in Benefits Section.
  },
  {
    benefits_heading: "Glitter Tattoos",
    benefits_text: "Temporary Glitter tattoos are the latest rage at parties. They are perfect for the “tween” and teen ages and are adored by adults! These bright glitter tattoos are waterproof, making them the ideal way to enhance any pool party. They last anywhere between 5-7 days on your skin and can be placed on hands, arms, shoulders, backs or feet.",
    button_label: "Call Now",
    button_url_link: "tel:+61408447829",
    button_url_new_tab: "*",
    benefits_image: "/assets/sticker.jpg",
    benefits_image_stretch_width: "100%",
  },
]



//? This is for configuring Call To Action Section of Index Page.
export const CallToActionConfig = {
  section_header: "Call To Action", //? This is for setting Heading Text in Call To Action Section of Index Page.
  section_sub_header: "", //? This is for setting Sub-Heading Text in Call To Action Section of Index Page.
  button_label: "Take Quiz", //? This is for setting Button Label in Call To Action Section. By default it will open Lead Form.
  
  //TODO: Don't fill this if "button_url_link" is filled.
//  button_page_link: "", //? This is for setting Page Link to the Button Label in Call To Action Section.

  //TODO: Don't fill this if "button_page_link" is filled.
//  button_url_link: "", //? This is for setting URL Link to the Button Label in Call To Action Section.
  
  //! IT IS BOOLEAN
//  button_url_new_tab: "", //? This is for controlling if the URL Link will be opened in a new window in Call To Action Section.
}



//? This is for configuring Lead Form.
export const FormConfig = {
  //TODO: Only turn it on if something written in "FormRadioData"
  //! IT IS BOOLEAN
  form_step_one: "y", //? This is for controlling if First Step in Lead Form will be showed.

  //TODO: Only turn it on if something written in "FormInputData"
  //! IT IS BOOLEAN
  form_step_two: "y", //? This is for controlling if Second Step in Lead Form will be showed.

  //TODO: Only turn it on if something written in "FormInputTextData"
  //! IT IS BOOLEAN
  form_step_three: "y", //? This is for controlling if Third Step in Lead Form will be showed.

  //TODO: Only turn it on if something written in "FormInputEmailData"
  //! IT IS BOOLEAN
  form_step_four: "y", //? This is for controlling if Fourth Step in Lead Form will be showed.

  //! IT IS BOOLEAN
  form_hide_back_button: "", //? This is for controlling if Back Button in Lead Form will be showed.

  //! IT IS BOOLEAN
  form_autocomplete_on: "y", //? This is for controlling if data will be auto completed in Lead Form.

  //! IT IS BOOLEAN
  form_price_formatted: "y", //? This is for controlling if Price will be Formatted in Lead Form.

  //! IT IS BOOLEAN
  form_total_value_formatted: "y", //? This is for controlling if Total Value will be Formatted in Lead Form.
  form_currency_sign: "$", //? This is for setting Currency Sign in Lead Form. Keeping it empty will hide Price from label.
  form_total_value_title: "Total Price", //? This is for setting Total Value in Lead Form. Keeping it empty will hide Total Price from Lead Form.

  form_firebase_link: "https://test-web-app-007-default-rtdb.firebaseio.com/", //? This is for setting Receive Firebase Link in Lead Form.
  form_firebase_auth: "8QLArKEM0HNqxTkoNXZy5DLafwpW0OHe3AK18XdZ", //? This is for setting Receive Firebase Auth Key in Lead Form.

  form_spam_email: "https://formsubmit.co/ajax/secretinspy007@gmail.com", //? This is for setting Spam Receive Email in Lead Form.

  form_email_subject: "Frequently Asked Questions", //? This is for setting Receive Email Subject in Lead Form.
  form_email: "https://formsubmit.co/ajax/secretinspy007@gmail.com", //? This is for setting Receive Email in Lead Form. Emaxple: https://formsubmit.co/ajax/lilyntalmers@gmail.com

  form_sheet_link: "", //? This is for setting Receive Sheet Link in Lead Form. Emaxple: https://api.sheetson.com/v2/sheets/TieForm
  form_authorization: "", //? This is for setting Receive Sheet Auth Key in Lead Form. Emaxple: Bearer YO5YlOLu4Xfujbt3os3KA843J3bjvHVGrmvZ1Pq-zk3IYT8zfgRm3osFIwc
  form_x_s_s_id: "", //? This is for setting Receive Sheet ID in Lead Form. Emaxple: 1rb0iSPn00Jd_TwHIl6jCfBfMRcAqE1dLsyeydQvW9_E
}



//? This is for adding Radio Questions Part in Lead Form.
//TODO: Turn it on inside "form_step_one"
//! IT IS ARRAY
export const FormRadioData = [
  // {
  //   form_radio_category: "", //? This is for setting Question in Radio Input Part of Lead Form.
  //   form_radio_help_image: "", //? This is for setting Help Image in Radio Input Part of Lead Form. It will be inside a dropdown under the input.
  //   form_radio_help_text: "", //? This is for setting Help Text in Radio Input Part of Lead Form. It will be under the Question.
    
  //! IT IS ARRAY
  //   form_radio_options: [
  //     {
  //       form_radio_sub_category: "", //? This is for setting Option for the Question in Radio Input Part of Lead Form.
  //       form_radio_price: , //? This is for setting Price for the Option in Radio Input Part of Lead Form. And there should be NO quotation marks (" ").
  //       form_radio_image: "", //? This is for setting Image for the Option in Radio Input Part of Lead Form.
  //     },
  //   ]
  // },
  {
    form_radio_category: "What type of Beaf do you like?",
    form_radio_help_image: "https://media.giphy.com/media/l4pLXMFYQmTM2se7m/giphy.gif",
    form_radio_help_text: "This is a demo descriptive text This is a demo descriptive text This is a demo descriptive text This is a demo descriptive text This is a demo descriptive text This is a demo descriptive text This is a demo descriptive text This is a demo descriptive text",
    form_radio_options: [
      {
        form_radio_sub_category: "Cheap Beaf",
        form_radio_price: 1000,
        form_radio_hide_price: "",
        form_radio_image: ""
      },
      {
        form_radio_sub_category: "Expensive Beaf",
        form_radio_price: 2000,
        form_radio_hide_price: "",
        form_radio_image: ""
      }
    ]
  },
  {
    form_radio_category: "Cheese",
    form_radio_help_image: "https://media.giphy.com/media/l4pLXMFYQmTM2se7m/giphy.gif",
    form_radio_help_text: "This is a demo descriptive text This is a demo descriptive text This is a demo descriptive text This is a demo descriptive text This is a demo descriptive text This is a demo descriptive text This is a demo descriptive text This is a demo descriptive text",
    form_radio_options: [
      {
        form_radio_sub_category: "Cheap Cheese",
        form_radio_price: 1000,
        form_radio_hide_price: "",
        form_radio_image: "https://www.xul.fr/en/css/images/20.jpg"
      },
      {
        form_radio_sub_category: "Expensive Cheese",
        form_radio_price: 2000,
        form_radio_hide_price: "",
        form_radio_image: "https://www.xul.fr/en/css/images/20.jpg"
      }
    ]
  },
  {
    form_radio_category: "Bread",
    form_radio_help_image: "",
    form_radio_help_text: "",
    form_radio_options: [
      {
        form_radio_sub_category: "Cheap Bread",
        form_radio_price: 400,
        form_radio_hide_price: "",
        form_radio_image: "https://www.xul.fr/en/css/images/20.jpg"
      },
      {
        form_radio_sub_category: "Expensive Bread",
        form_radio_price: 2000,
        form_radio_hide_price: "",
        form_radio_image: "https://www.xul.fr/en/css/images/20.jpg"
      }
    ]
  }
]



//? This is for adding Text Questions Part in Lead Form.
//TODO: Turn it on inside "form_step_two"
//! IT IS ARRAY
export const FormInputData = [
  // {
  //   form_field_name: "", //? This is for setting Question in Text Input Part of Lead Form.
  //   form_input_price: , //? This is for setting Price in Text Input Part of Lead Form. And there should be NO quotation marks (" ").

  //! IT IS BOOLEAN
  //   form_input_required: "", //? This is for controlling if this Quetion in Text Input Part of Lead Form will be required to fill.
  //   form_input_help_image: "", //? This is for setting Help Image in Text Input Part of Lead Form. It will be inside a dropdown under the input.
  //   form_input_help_text: "", //? This is for setting Help Text in Text Input Part of Lead Form. It will be under the Question.
  // },
  {
    form_field_name: "City Name",
    form_input_price: -10,
    form_input_hide_price: "",
    form_input_required: "",
    form_input_help_image: "",
    form_input_help_text: "",
  },
  {
    form_field_name: "Zip Code",
    form_input_required: "",
    form_input_help_image: "https://media.giphy.com/media/l4pLXMFYQmTM2se7m/giphy.gif",
    form_input_help_text: "This a demo descriptive text This is a demo descriptive text This is a demo descriptive text This is a demo descriptive text This is a demo descriptive text",
  },
]



//? This is for adding Paragraph Questions Part in Lead Form.
//TODO: Turn it on inside "form_step_three"
//! IT IS ARRAY
export const FormInputTextData = [
  // {
  //   form_field_name: "", //? This is for setting Question in Paragraph Input Part of Lead Form.
  //   form_input_price: , //? This is for setting Price in Paragraph Input Part of Lead Form. And there should be NO quotation marks (" ").

  //! IT IS BOOLEAN
  //   form_input_required: "", //? This is for controlling if this Quetion in Paragraph Input Part of Lead Form will be required to fill.
  //   form_input_help_image: "", //? This is for setting Help Image in Paragraph Input Part of Lead Form. It will be inside a dropdown under the input.
  //   form_input_help_text: "", //? This is for setting Help Text in Paragraph Input Part of Lead Form. It will be under the Question.
  // },
  {
    form_field_name: "Secret Message",
    form_input_price: 50,
    form_input_hide_price: "",
    form_input_required: "",
    form_input_help_image: "",
    form_input_help_text: "",
  },
  {
    form_field_name: "Hyper Secret Message",
    form_input_required: "",
    form_input_help_image: "https://media.giphy.com/media/l4pLXMFYQmTM2se7m/giphy.gif",
    form_input_help_text: "This a demo descriptive text This is a demo descriptive text This is a demo descriptive text This is a demo descriptive text This is a demo descriptive text",
  },
]



//? This is for configuring Email Asking Part in Lead Form.
//TODO: Turn it on inside "form_step_four"
export const FormInputEmailData = {
  //! IT IS BOOLEAN
  form_input_required: "yes", //? This is for controlling if Email in Email Input Part of Lead Form will be required to fill.
  form_input_help_text: "We will only use this email to send you valuable information and won't send a single spam email because your email is already full of them and you don't need one more!", //? This is for setting Help Text in Email Input Part of Lead Form. It will be under the input.
}